"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.focus = void 0;
exports.focus = function (modalId) {
    jQuery(modalId).find('button').first().trigger('focus');
};
